import React from 'react'
import PropTypes from 'prop-types'
import loadable from '@loadable/component'
import {
    Modal,
    ModalBody,
    ModalContent,
    ModalOverlay,
    Flex,
    Text,
    IconButton,
    Icon,
    Skeleton,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {CustomClose} from '../icons'
import UnselectedVariationGroups from './partials/unselected-variation-groups'

const FindInStore = loadable(() => import('./partials/find-in-store-content'), {
    fallback: <Skeleton height="400px" width="100%" />,
    ssr: false
})

const FindInStoreModal = ({
    isOpen,
    onClose,
    isVariantSelected,
    setIsVariantSelected,
    findInStoreModalTitle,
    setFindInStoreModalTitle,
    variant,
    productWithPromotions,
    productName,
    variationAttributes
}) => {
    const styles = useMultiStyleConfig('FindInStoreModal', {})

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            size={!isVariantSelected ? 'xl' : 'full'}
            motionPreset="none"
            isCentered={false}
        >
            <ModalOverlay />
            <ModalContent {...styles.content} maxWidth={!isVariantSelected && '448px'}>
                <ModalBody {...styles.body}>
                    <Flex
                        {...styles.header}
                        p={isVariantSelected ? {base: 4, lg: 6} : {base: 4}}
                        position={isVariantSelected ? {base: 'absolute'} : {base: 'sticky'}}
                        right={isVariantSelected && {base: 0}}
                        maxWidth={isVariantSelected && {md: '448px'}}
                    >
                        <Text {...styles.title}>{findInStoreModalTitle}</Text>
                        <IconButton
                            onClick={onClose}
                            icon={<Icon as={CustomClose} />}
                            aria-label="Close modal"
                            {...styles.closeButton}
                        />
                    </Flex>
                    {isVariantSelected ? (
                        <FindInStore
                            onFindInStoreClose={onClose}
                            product={variant || productWithPromotions}
                            masterProduct={productWithPromotions}
                            setFindInStoreModalTitle={setFindInStoreModalTitle}
                            productName={productName}
                        />
                    ) : (
                        <UnselectedVariationGroups
                            setIsVariantSelected={setIsVariantSelected}
                            variant={variant}
                            variationAttributes={variationAttributes}
                            setFindInStoreModalTitle={setFindInStoreModalTitle}
                        />
                    )}
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

FindInStoreModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    isVariantSelected: PropTypes.bool.isRequired,
    setIsVariantSelected: PropTypes.func.isRequired,
    findInStoreModalTitle: PropTypes.string,
    setFindInStoreModalTitle: PropTypes.func.isRequired,
    variant: PropTypes.object,
    productWithPromotions: PropTypes.object,
    productName: PropTypes.string,
    variationAttributes: PropTypes.array
}

export default FindInStoreModal
